import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Video } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicMeeting() {
    const { token } = useParams();
    const [state, setState] = useState({ loading: true, error: null, data: null });
    const [joined, setJoined] = useState(false);
    const [displayName, setDisplayName] = useState('');

    useEffect(() => {
        axios.get(`${API}/meeting-invites/${token}`)
            .then(r => setState({ loading: false, error: null, data: r.data }))
            .catch(e => setState({ loading: false, error: e.response?.data?.detail || e.message, data: null }));
    }, [token]);

    if (state.loading) return (
        <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin" /></div>
    );

    if (state.error) return (
        <div className="min-h-screen flex items-center justify-center p-6">
            <div className="max-w-md w-full card-soft p-10 text-center" data-testid="meeting-public-error">
                <h1 className="font-heading text-2xl mb-3 text-foreground">Lien invalide</h1>
                <p className="text-foreground/70 mb-6">{state.error}</p>
                <Link to="/" className="text-sm text-primary underline">Retour à l'accueil</Link>
            </div>
        </div>
    );

    if (joined) {
        const { data } = state;
        const url = `${data.jitsi_url}#userInfo.displayName="${encodeURIComponent(displayName)}"&config.startWithAudioMuted=false&config.startWithVideoMuted=false&config.prejoinPageEnabled=false`;
        return (
            <div className="fixed inset-0 bg-black flex flex-col" data-testid="meeting-public-embed">
                <div className="bg-foreground text-background px-4 py-3 flex items-center justify-between">
                    <div>
                        <div className="text-sm font-medium">{data.title || 'Réunion'}</div>
                        <div className="text-xs opacity-60">Invité externe : {displayName}</div>
                    </div>
                </div>
                <iframe src={url} allow="camera; microphone; fullscreen; display-capture; autoplay"
                    className="flex-1 w-full" title="Jitsi Meeting" data-testid="meeting-public-iframe" />
            </div>
        );
    }

    const { data } = state;
    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">
            <div className="max-w-md w-full card-soft p-10 text-center" data-testid="meeting-public-prejoin">
                <div className="h-16 w-16 rounded-full bg-primary-light text-primary mx-auto flex items-center justify-center mb-5">
                    <Video size={26} />
                </div>
                <h1 className="font-heading text-3xl mb-2">{data.title || 'Réunion projet'}</h1>
                <p className="text-foreground/70 mb-6">Vous êtes invité(e) à rejoindre cette réunion African Valley.</p>
                <Input placeholder="Votre nom (visible aux autres participants)" value={displayName}
                    onChange={(e) => setDisplayName(e.target.value || data.guest_name || '')}
                    className="mb-4 text-center" data-testid="meeting-public-name" />
                <Button onClick={() => setJoined(true)} disabled={!displayName.trim()}
                    className="w-full h-12 bg-primary hover:bg-primary-hover" data-testid="meeting-public-join">
                    <Video size={14} className="mr-2" /> Rejoindre la réunion
                </Button>
                <p className="text-xs text-muted-foreground mt-4">Caméra et microphone seront activés. Vous pourrez les couper depuis l'interface.</p>
            </div>
        </div>
    );
}
